<ng-container *ngIf="initialized">

    <div class="grid mx-0 my-3 overflow-y-auto h-full">
        <div class="col-5 pt-0 mb-3">
            <mvs-widget class="shadow-1 block border-round mvs-widget"
                    *ngIf="widgetTestCases"
                    [widgetData]="widgetTestCases"
                    (onObjectSelect)="handleTestCaseSelect($event)"
            ></mvs-widget>
        </div>

        <div class="col-7 pt-0 mb-3">
            <mvs-widget  class="shadow-1 block border-round mvs-widget sticky top-0"
                    *ngIf="widgetTestCaseVariables"
                    [widgetData]="widgetTestCaseVariables"
                    [importObjectContext]="importContext"
            ></mvs-widget>
        </div>

    </div>

</ng-container>